export const PWA_OFFLINE_READY = 'pwa-offline-ready';
export const PWA_UPDATE_AVAILABLE = 'pwa-update-available';

export type PWAEventType = 'offline-ready' | 'update-available';

export interface PWAUpdateDetail {
  registration: ServiceWorkerRegistration;
}

export function dispatchPWAEvent(
  type: PWAEventType,
  registration?: ServiceWorkerRegistration
): void {
  const eventName = type === 'offline-ready' ? PWA_OFFLINE_READY : PWA_UPDATE_AVAILABLE;
  const detail = type === 'update-available' && registration ? { registration } : undefined;
  window.dispatchEvent(
    new CustomEvent(eventName, { detail: detail as PWAUpdateDetail | undefined })
  );
}
